export const ROUTE_PARAM_SRC_CHAIN = "source"
export const ROUTE_PARAM_DST_CHAIN = "destination"
export const ROUTE_PARAM_TOKEN = "token"
export const ROUTE_PARAM_ASSET = "asset_denom"
export const ROUTE_PARAM_DESTINATION_ADDRESS = "destination_address"
